import { usePlaidLink } from "react-plaid-link";

type Metadata = { accounts?: { id: string }[] };

const DEFAULT_CLASS =
  "rounded-lg bg-[var(--green)] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[var(--green-dark)] disabled:cursor-not-allowed disabled:opacity-50";

export function PlaidLinkLaunchButton({
  linkToken,
  onPlaidSuccess,
  label = "Link bank with Plaid",
  className,
}: {
  linkToken: string;
  onPlaidSuccess: (publicToken: string, metadata: Metadata) => void;
  /** e.g. "Update bank with Plaid" on account settings. */
  label?: string;
  /**
   * Optional Tailwind className override. When omitted, the default
   * `var(--green)` button matches Phase 1B Account / Checkout / Identity
   * call sites. Pass a custom class for non-default placements.
   */
  className?: string;
}) {
  const { open, ready } = usePlaidLink({
    token: linkToken,
    onSuccess: (publicToken, metadata) => {
      onPlaidSuccess(publicToken, metadata);
    },
  });

  return (
    <button
      type="button"
      disabled={!ready}
      onClick={() => open()}
      className={className ?? DEFAULT_CLASS}
    >
      {label}
    </button>
  );
}
